import { PRODUCT_ADD_SUCCESS, PRODUCT_ADD_FAILURE } from '../constants';

const initState = [];

const productsReducer = (state = initState, action) => {
  switch (action.type) {
    case PRODUCT_ADD_SUCCESS:
      return [
        ...state
        // action.payload
      ];
    default:
      return state;
  }
};

export default productsReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/productsReducer.js